<!-- 模块-优惠券 -->
<template>
  <div>
    <div class="b_card" v-for="(val, key) in data_useable" :key="key" :style="{'background-image': 'url(' + (val.bg_back) + ')'}">
      <van-row  @click="exchange">
        <van-col span="24" style="font-size:18px">满 {{val.trigger}}可用 {{val.money}} 满减</van-col>
        <van-col span="18" style="margin:10px 0;font-size:12px">{{val.explain}}</van-col>
        <van-col span="6" style="text-align:right;"><van-button round  plain  size="small" style="background:transparent;color:#fff">立即兑换</van-button></van-col>
        <van-col span="24"><van-button color="tomato" plain size="small" style="border-radius: 10px;">100积分</van-button></van-col>
      </van-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .b_card {
    padding: 10px;
    height: auto;
    margin:10px 0;
    box-shadow: 3px 3px 3px #ccc;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
</style>

<script>
export default {
  name: 'coupon',
  data () {
    return {
      show_integral: false,
      data_useable: [
        {
          type: 1,
          status: 1,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50,
          bg_back: require('@/assets/Generalledgercard_bg.png')
        },
        {
          type: 2,
          status: 1,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50,
          bg_back: require('@/assets/billingcard_bg.png')
        },
        {
          type: 3,
          status: 1,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50,
          bg_back: require('@/assets/discountcard_bg.png')
        },
        {
          type: 4,
          status: 1,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50,
          bg_back: require('@/assets/rechargecard_bg.png')
        }
      ]
    }
  },
  methods: {
    // 展示优惠券兑换弹框
    exchange () {
      this.$dialog({
        title: '兑换积分',
        message: '是否确定兑换100积分',
        showCancelButton: true,
        confirmButtonText: '确认兑换',
        cancelButtonText: '再想想'
      }).then(() => {
        this.$notify({ type: 'success', message: '兑换成功' })
      })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inte_store/coupon.vue